import {
  getSoulMapLearningPath,
  getSoulMapLearningPathTag,
  getSoulMapStepPrompt,
} from '@/utils/soulmap-learning-path';
import { useMyLearningPaths } from './index';

export function useSoulMapLearningPath(options?: {
  enabled?: boolean;
  /** 0-based step in the learning path (0 = first prompt / session 1). */
  stepIndex?: number;
}) {
  const tag = getSoulMapLearningPathTag();
  const stepIndex = options?.stepIndex ?? 0;
  const query = useMyLearningPaths({ tag }, { enabled: options?.enabled });

  const learningPath = getSoulMapLearningPath(query.data);
  const prompt = getSoulMapStepPrompt(learningPath, stepIndex);

  return {
    ...query,
    tag,
    learningPath,
    prompt,
  };
}
